var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "module-content" },
    [
      _c("div", { staticClass: "module-header" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "router-link",
              {
                staticClass: "back",
                attrs: {
                  to: "/users",
                  title: "Back to list",
                  "select-cy": "back"
                }
              },
              [_c("i", { staticClass: "icn icn-chevron-left" })]
            ),
            _c("h2", [
              _vm.itemLoaded
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.item.firstName) +
                        " " +
                        _vm._s(_vm.item.lastName)
                    )
                  ])
                : _vm._e(),
              !_vm.itemLoaded ? _c("span", [_vm._v("Loading")]) : _vm._e()
            ])
          ],
          1
        ),
        _c("div", { staticClass: "right" }, [
          _vm.canDelete
            ? _c(
                "button",
                {
                  staticClass: "action delete",
                  attrs: { title: "Delete item", "select-cy": "delete" },
                  on: {
                    click: function($event) {
                      return _vm.deleteItem()
                    }
                  }
                },
                [_c("i", { staticClass: "icn icn-trash sm" })]
              )
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "content w-full" }, [
        _vm.isLoading
          ? _c("div", { staticClass: "container w-max" }, [_vm._m(0)])
          : _vm._e(),
        _vm.itemLoaded
          ? _c("div", { staticClass: "container module-item" }, [
              _c("div", { staticClass: "section" }, [
                _c("div", { staticClass: "head" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("h3", [_vm._v("User Details")]),
                    _c("p", { staticClass: "sub-title" }, [
                      _vm._v(
                        " Created: " +
                          _vm._s(
                            _vm._f("date")(
                              _vm.item.createdAt,
                              "dd-MM-yyyy HH:mm"
                            )
                          ) +
                          " - Last Updated: " +
                          _vm._s(
                            _vm._f("date")(
                              _vm.item.updatedAt,
                              "dd-MM-yyyy HH:mm"
                            )
                          ) +
                          " "
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "body halved" }, [
                  _c("div", { staticClass: "details" }, [
                    _c("div", { staticClass: "intro" }, [
                      _c("h4", [_vm._v("General Information")]),
                      _vm.canEdit
                        ? _c(
                            "a",
                            {
                              staticClass: "edit",
                              attrs: { "select-cy": "edit-details" },
                              on: {
                                click: function($event) {
                                  return _vm.open(_vm.modalNames.EDIT_DETAILS)
                                }
                              }
                            },
                            [_vm._v("Edit Details")]
                          )
                        : _vm._e()
                    ]),
                    _c("dl", { staticClass: "fields desc" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("dt", { staticClass: "label" }, [
                          _vm._v("First Name")
                        ]),
                        _c("dd", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.item.firstName))
                        ])
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("dt", { staticClass: "label" }, [
                          _vm._v("Last Name")
                        ]),
                        _c("dd", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.item.lastName))
                        ])
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("dt", { staticClass: "label" }, [_vm._v("Email")]),
                        _c("dd", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.item.email))
                        ])
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("dt", { staticClass: "label" }, [_vm._v("Company")]),
                        _c("dd", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.item.company ? _vm.item.company.name : "-"
                            )
                          )
                        ])
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "details" }, [
                    _c("div", { staticClass: "intro" }, [
                      _c("h4", [_vm._v("Security")]),
                      _vm.canEdit
                        ? _c(
                            "a",
                            {
                              staticClass: "edit",
                              on: {
                                click: function($event) {
                                  return _vm.open(
                                    _vm.modalNames.SECURITY_DETAILS
                                  )
                                }
                              }
                            },
                            [_vm._v("Edit Details")]
                          )
                        : _vm._e()
                    ]),
                    _c("dl", { staticClass: "fields desc" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("dt", { staticClass: "label" }, [_vm._v("SSO ID")]),
                        _c("dd", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.item.ssoId))
                        ])
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("dt", { staticClass: "label" }, [
                          _vm._v("Created Date")
                        ]),
                        _c("dd", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(
                                _vm.item.creationDate,
                                "dd-MM-yyyy HH:mm"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm.isSuperAdmin
                        ? _c("div", { staticClass: "field" }, [
                            _c("dt", { staticClass: "label" }, [
                              _vm._v("Super Admin")
                            ]),
                            _c("dd", { staticClass: "value" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "badge",
                                  class: _vm.item.isSuperAdmin ? "green" : "red"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.item.isSuperAdmin ? "Yes" : "No"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "field" }, [
                        _c("dt", { staticClass: "label" }, [
                          _vm._v("Account Status")
                        ]),
                        _c("dd", { staticClass: "value" }, [
                          _c(
                            "span",
                            {
                              staticClass: "badge",
                              class: _vm.item.isEnabled ? "green" : "red"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.item.isEnabled ? "Enabled" : "Disabled"
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm.canEdit
                        ? _c("div", { staticClass: "field" }, [
                            _c("dt", { staticClass: "label" }, [
                              _vm._v("Send Reset Password Email")
                            ]),
                            _c("dd", { staticClass: "value" }, [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.resetPassword()
                                    }
                                  }
                                },
                                [_vm._v("Reset Password")]
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm.itemNotFound
          ? _c("div", { staticClass: "container" }, [_vm._v("Item Not found")])
          : _vm._e()
      ]),
      _vm.isEditDetailsOpen ? _c("UserEditDetails") : _vm._e(),
      _vm.isSecurityDetailsOpen ? _c("UserEditSecurityDetails") : _vm._e(),
      _vm.isGrantRoleOpen ? _c("UserGrantRole") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col items-center" }, [
      _c("img", {
        staticClass: "h-36 mt-20",
        attrs: { src: require("@/assets/img/loading.svg") }
      }),
      _c("h2", [_vm._v("Fetching item")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }